import * as React from 'react';
import { Label } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';

// eslint-disable-next-line import/no-restricted-paths
import { ILabelSchema } from '../../../node/repositories/newbuilding-card/entities/reviews/LabelSchema';

export interface IReviewLabelsProps {
  labels: ILabelSchema[];
}

export const ReviewLabels: React.FC<IReviewLabelsProps> = ({ labels }) => {
  return <Label background={labels[0].color as TColors}>{labels[0].text}</Label>;
};
